import { ComparisonType } from "~pages/LeaderCriteria/enums/comparisonType.ts";

export const COMPARISON_TYPE_SYMBOLS: Record<ComparisonType, string> = {
  [ComparisonType.EQUAL]: "=",
  [ComparisonType.GREATER_THAN]: ">",
  [ComparisonType.GREATER_THAN_EQUAL]: ">=",
  [ComparisonType.LESS_THAN]: "<",
  [ComparisonType.LESS_THAN_EQUAL]: "<=",
};

export const COMPARISON_TYPE_OPTIONS = Object.values(ComparisonType).map((comparisonType) => ({
  value: comparisonType,
  label: COMPARISON_TYPE_SYMBOLS[comparisonType],
}));
